/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect, useState } from "react";
import { SimpliCitySDK } from "cms/sdk";
import { useAuth } from "cms/auth/hooks/useAuth";
import { isValidGuid } from "../utils/empty-exists";

const useSimWebpage = (webpage_guid) => {

    const { token } = useAuth();
    const [webpage,setWebpage] = useState();
    const [inProgress,setInProgress] = useState(false);
    const [loaded,setLoaded] = useState(false);

    useEffect(() => {
        const getWebpage = async (guid) => {
            setInProgress(true);
            if (isValidGuid(guid) && !inProgress && !loaded) {
                const _webpage = await SimpliCitySDK.webpage.findOne(token, guid);
                setWebpage(_webpage);
            }
            setInProgress(false);
            setLoaded(false);
        };
        getWebpage(webpage_guid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [webpage_guid]);

    return { webpage, loaded };
};

export { useSimWebpage };
